import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { HeaderComponent } from 'src/app/layout/header/header.component';
import { CommonServiceService } from '../services/common-service.service';
import { environment } from 'src/environments/environment';
import { TncDialogComponent } from '../tnc/tnc-dialog/tnc-dialog.component';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  ADMIN_ROLE = 1;
  show: any;
  isEmail = false;
  constructor(
    public dialogRef: MatDialogRef<HeaderComponent>, public dialog: MatDialog,
    private commonservice: CommonServiceService, public router: Router, private snackBar: MatSnackBar
  ) { }
  username: any = '';
  password: any = '';
  imageCaptcha = '';
  captcha: any ;
  loginFailedDueToCaptcha = '';
  captchaId = '';
  loginMessage: string[] = ['Invalid credential', 'Incorrect captcha'];
  ngOnInit(): void {
    this.getNewCaptcha();
  }

  close(): void {
    this.dialogRef.close();
  }

  showPassword(): void {
    this.show = !this.show;
  }

  loginuser(): void {
    if (this.username === '' && this.password === ''){
      this.openSnackBar(['Please Enter Username and Password !!']);
      return;
    }
    if (this.username === '' ){
      this.openSnackBar(['Please Enter Username !!']);
      return;
    }
    if ( this.password === ''){
      this.openSnackBar(['Please Enter  Password !!']);
      return;
    }
    if (!this.captcha){
      this.openSnackBar(['Please Enter captcha !!']);
      return;
    }

    const random = Math.random();
    const password = this.password;
    const cipherText = this.commonservice.getSecratKey(environment.secratKey, password);
    const randomKey = random.toString();
    const encryptCiphertextRandom = this.commonservice.getSecratKey(randomKey, cipherText);
    const data = {
      username: this.username,
      password: encryptCiphertextRandom,
      random : randomKey,
      captcha_id: this.captchaId,
      captchaText: this.captcha
    };

    this.commonservice.formGetMethod('user/view' , { email: this.username }).subscribe((userViewRes: any) => {
      this.commonservice.loginService(data).subscribe(async (res: any) => {
        if (res.success){
          const responseData = JSON.parse(JSON.stringify(res));
          sessionStorage.setItem('userdata', JSON.stringify(res?.data));
          sessionStorage.setItem('token', res.token);
          this.loginToFormIO().then((x: any) => {
            const token = x.body['x-jwt-token'];
            sessionStorage.setItem('jwtToken', token);

            sessionStorage.removeItem('captcha_id');
            this.getDistroyCaptcha(false);

            if (responseData?.data?.role_id){
              this.permissonUserList(responseData?.data?.role_id).then((result: any) => {
                if (result === 'succes'){
                  this.dialogRef.close({isLoggedIn: true, message: res?.message});
                }
              });
            }else{
              this.openSnackBar(['User Permission not allowed ']);
            }
          });
        }
      }, (error) => {
        const messageCheck = 'Your login is currently restricted.';
        if (error.error.message.includes(messageCheck)) {
          this.openSnackBar(error.error.message, '', false, 6000);

        } else{
          this.openSnackBar(error.error.message, '', false, 3000);
        }
        const isInvalidCredtional =  this.loginMessage.includes(error.error.message);
        this.getDistroyCaptcha(isInvalidCredtional);
        this.refreshCaptcha();
      });
  },
  (error: any) => {
    this.openSnackBar([error?.error?.message || 'Failed !'], '');
  });

  }

  async loginToFormIO(): Promise<any> {
    const logindata = {
      method: 'POST',
      endpoint: '/user/login',
      headers: {
        'Content-Type': 'application/json'
      },
      requestBody: {
        data: {
          email: this.username,
          password: this.password
        }
      }
    };
    return this.commonservice.loginFormIOservice(logindata).toPromise();
  }

  checkFooter(footerStatus: any): void {
    this.commonservice.updateResouceCount(footerStatus);
  }

  openSnackBar(message: any, action = '', isSuuces: boolean= false, duration: number = 3000): void {
    this.snackBar.open(message, action, {
      duration,
      panelClass: !isSuuces ? ['primary'] : ''
    });
  }

async openSignUpForm(): Promise<void> {
  this.router.navigate(['home']);
  const signUp = await import('../sign-up/sign-up.component');
  this.dialog.open(signUp.SignUpComponent, {
    width: '750px',
    panelClass: 'signUp-dialog-class',
    disableClose: true,
  });
  this.dialogRef.close();
}

openForgotDialog(): void {
  this.router.navigate(['forgot-password']);

  this.dialogRef.close();
}
refreshCaptcha(): void {
  let captcha: any = sessionStorage.getItem('captcha_id');
  captcha = JSON.parse(captcha);
  this.commonservice.refreshCaptch(captcha).subscribe((res: any) => {
    if (res.success){
      this.captchaId = '';
      this.getNewCaptcha();
    }
  }, (error: any) => {
    this.openSnackBar(error?.error?.message);
  });
}
getNewCaptcha(): void {
  this.commonservice.captchaData().subscribe((res: any) => {
    if (res.success){
      this.imageCaptcha = res?.data?.captcha;
      sessionStorage.setItem('captcha_id', JSON.stringify(res?.data?.id));
      this.captchaId = res?.data?.id;
    }
  }, (error: any) => {
    this.openSnackBar(error?.error?.message);
  });

}
getDistroyCaptcha(isDistroy: boolean= false): void {
  this.commonservice.destroyRefreshCaptcha(this.captchaId).subscribe((res: any) => {
    if (res.success){
      this.captchaId = '';
      this.imageCaptcha = '';
      this.captcha = '';
      if (isDistroy) { this.getNewCaptcha(); }
    }
  });
}

async permissonUserList(roleId: string): Promise<any> {
  return new Promise((resolve, reject) => {
    this.commonservice.getRoleDataById(roleId).subscribe((res: any) => {
      res = JSON.parse(JSON.stringify(res.data));
      if (res){
        sessionStorage.setItem('userPermission', JSON.stringify(res));

        resolve('succes');
      }
    }, (permissionErr) => {
      this.dialogRef.close(false);
      this.openSnackBar(permissionErr.error.message);
      reject('error');
    });
  });
}
landingPageWithAuthentication(data: any): void {
  const module = data.find((el: any) => el?.model === 'cms');
  const isManagePortal: boolean = module.some(
    (el: any) => (el?.is_checked || el?.isAction) || el?.authentication.some((authItem: any) => authItem?.isAction)
  );
  isManagePortal ? this.router.navigate(['/manage-portal']) : this.router.navigate(['/home']);
}
validateMethod(): void {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(this.username) || !this.username){
      this.isEmail = false;
    }
    else{
      this.isEmail = true;
    }
}

openTncFormDialog(data: any): void {
  const dialogRef = this.dialog.open(TncDialogComponent, {
    width: '100vw',
    height: '80vh',
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      this.commonservice.loginService(data).subscribe(async (res: any) => {
        if (res.success){
          const responseData = JSON.parse(JSON.stringify(res));
          sessionStorage.setItem('userdata', JSON.stringify(res?.data));
          sessionStorage.setItem('token', res.token);
          this.loginToFormIO().then((x: any) => {
            const token = x.body['x-jwt-token'];
            sessionStorage.setItem('jwtToken', token);

            sessionStorage.removeItem('captcha_id');
            this.getDistroyCaptcha(false);

            if (responseData?.data?.role_id){
              this.permissonUserList(responseData?.data?.role_id).then((permissionResult: any) => {
                if (permissionResult === 'succes'){
                  this.dialogRef.close({isLoggedIn: true, message: res?.message});
                }
              });
            }else{
              this.openSnackBar(['User Permission not allowed ']);
            }
          });
        }
      }, (error) => {
        const messageCheck = 'Your login is currently restricted.';
        if (error.error.message.includes(messageCheck)) {
          this.openSnackBar(error.error.message, '', false, 6000);

        } else{
          this.openSnackBar(error.error.message, '', false, 3000);
        }
        const isInvalidCredtional =  this.loginMessage.includes(error.error.message);
        this.getDistroyCaptcha(isInvalidCredtional);
        this.refreshCaptcha();
      });
    }
  });
}

}
